export * from './lib/shared-ng-feature-gtm.module';
export * from './lib/google-tag-manager.service';
export * from './lib/google-tag-manager-config';
export * from './lib/google-tag-manager-config.service';
